import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Route as Match, NavLink, withRouter } from 'react-router-dom';
import cn from 'classnames/bind';
import styles from './Header.scss';

import Logo from './Logo/Logo';
import Search from './Search/Search';
import User from './User/User';
import FiltersBar from './FiltersBar';
import Notification from 'components/Notification';
import iconBuilding from 'assets/images/icons/header-item-building.svg';
import iconCollections from 'assets/images/icons/header-item-collections.svg';
import iconFavorites from 'assets/images/icons/header-item-favorites.svg';
import iconHome from 'assets/images/icons/web-page-home.svg';
import withValidTrafic from 'decorators/withValidTrafic';
import withObservePayments from 'decorators/withObservePayments';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';

const cx = cn.bind(styles);

const NEW_HOUSES = 'NEW_HOUSES';
const COTTAGESS = 'COTTAGESS';

@withObservePayments
@withValidTrafic(true)
class Header extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      headerIsPin: true
    };

    this.pinHandler = this.pinHandler.bind(this);
    this.unpinHandler = this.unpinHandler.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { currentBuilding, isCurrentBuildingLoading, location: { pathname } } = nextProps;
    const isSingleBuildingPage = (/building\/\d*/g).test(pathname);
    const isCurrentBuildingTypeIsCottage = currentBuilding ? currentBuilding.type_id === 2 : false;

    if (isSingleBuildingPage) {
      if (!isCurrentBuildingLoading && currentBuilding) {
        if (!isCurrentBuildingTypeIsCottage && (location.pathname === '/' || location.pathname.match(/building/))) {
          this.setState({ activeLink: NEW_HOUSES });
        } else if (isCurrentBuildingTypeIsCottage || location.pathname === '/cottages' || !!location.pathname.match(/cottages/)) {
          this.setState({ activeLink: COTTAGESS });
        } else {
          this.setState({ activeLink: null });
        }
      }
    } else if (location.pathname === '/' || location.pathname.match(/building/)) {
      this.setState({ activeLink: NEW_HOUSES });
    } else if (location.pathname === '/cottages' || !!location.pathname.match(/cottages/)) {
      this.setState({ activeLink: COTTAGESS });
    } else {
      this.setState({ activeLink: null });
    }
  }

  pinHandler(whatever) {
    this.setState({ headerIsPin: true });
  }

  unpinHandler(whatever) {
    this.setState({ headerIsPin: false });
  }

  isCollectionsLinkActive = (match, location) => (
    location.pathname.match(/collection(s)?/)
  )

  onBuildingClick = (e) => {
    e.preventDefault();
    const filters = sessionStorage.getItem('filtersUrl');

    tracker.sendEvent('Web_ZHK');
    if (filters.includes('/cottages')) {
      this.props.history.push(this.props.to || '/');
    } else {
      this.props.history.push(sessionStorage.getItem('filtersUrl') || this.props.to || '/');
    }
    // console.log(sessionStorage.getItem('filtersUrl'));
    // this.props.push(sessionStorage.getItem('filtersUrl') || this.props.to || '/');
    // this.props.push(this.props.to || '/');
  }

  onCottegesClick = (e) => {
    e.preventDefault();

    tracker.sendEvent('Web_KP');
    this.props.history.push('/cottages');
  }

  render() {
    const { className, authentication, isBlocked, t } = this.props;
    const { activeLink } = this.state;

    return (authentication.authenticated ?
      <div className={styles.HeaderMainWrap}>
        <div className={styles.HeaderWrap}>
          <div className={cx(styles.Header, className, 'global-header-class')}>
            <Logo className={styles.Logo} />
            { authentication.authenticated && !isBlocked ?
              <Search
                className={styles.Search}
              /> : null
            }
            <div className={styles.LinksUser}>
              {!isBlocked && <div className={styles.HeaderLinks}>
                <a href="#" className={cx({ [styles.active]: activeLink === NEW_HOUSES })} onClick={this.onBuildingClick}>
                  <i>
                    <img src={iconBuilding} alt={t('components.header.menu.building')} />
                  </i>
                  <span>
                    {t('components.header.menu.building')}
                  </span>
                </a>
                <a href="#" className={cx({ [styles.active]: activeLink === COTTAGESS })} onClick={this.onCottegesClick}>
                  <i>
                    <img src={iconHome} alt={t('components.header.menu.kpAndTh')} />
                  </i>
                  <span>
                    {t('components.header.menu.kpAndTh')}
                  </span>
                </a>
                <NavLink
                  to="/collections"
                  activeClassName={styles.active}
                  isActive={this.isCollectionsLinkActive}
                  onClick={() => tracker.sendEvent('Web_Selections')}
                >
                  <i>
                    <img src={iconCollections} alt={t('components.header.menu.collections')} />
                  </i>
                  <span>
                    {t('components.header.menu.collections')}
                  </span>
                </NavLink>
                <NavLink
                  to="/favorites"
                  activeClassName={styles.active}
                >
                  <i>
                    <img src={iconFavorites} alt={t('components.header.menu.favorites')} />
                  </i>
                  <span>
                    {t('components.header.menu.favorites')}
                  </span>
                </NavLink>
              </div>}
              {authentication.authenticated && <User className={styles.User} isBlocked={isBlocked} />}
            </div>
          </div>
        </div>
        {!isBlocked && <Match exact path="/" component={FiltersBar} />}
        {!isBlocked && <Match exact path="/cottages" component={FiltersBar} />}
        <Notification />
      </div> : null
    );
  }
}

const headerSelector = createSelector(
  state => state.authentication,
  state => state.building.data,
  state => state.building.isLoading,
  (authentication, currentBuilding, isCurrentBuildingLoading) => ({
    authentication,
    currentBuilding,
    isCurrentBuildingLoading
  })
);

export default connect(headerSelector)(withRouter(withTranslation()(Header)));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js